import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center bg-black px-6 pt-24 md:pt-6 overflow-hidden" data-id="element-133">
      {/* Cinematic Background */}
      <div className="absolute inset-0 z-0" data-id="element-134">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat animate-[zoom_20s_infinite_alternate]" style={{
        backgroundImage: "url('https://cdn.magicpatterns.com/uploads/o3BypcBsCPH8Y2k63xNZ7Z/j-square-filming-thailand-28.jpg')",
        transform: 'scale(1.1)'
      }} data-id="element-135" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "0px",
        paddingRight: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-136" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="mb-8 flex flex-col items-center" data-id="element-138">
          <span className="text-[#c9a961] text-[15px] md:text-[17px] font-medium tracking-[0.2em] uppercase mb-4" data-id="element-139">
            {t.hero.subtitle}
          </span>
          <div className="w-16 h-[1px] bg-[#c9a961]/60" data-id="element-140" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-display text-white text-[56px] md:text-[80px] lg:text-[100px] font-medium leading-[1.05] tracking-tight mb-8" data-id="element-141">
          {t.hero.title1}
          <br data-id="element-142" />
          <span className="text-[#c9a961] italic" data-id="element-143">{t.hero.title2}</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-white/80 text-[19px] md:text-[22px] font-light leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-144">
          {t.hero.description}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" style={{
        marginTop: "20px",
        marginBottom: "20px"
      }} data-id="element-145">
          <a href="#businesses" className="inline-flex items-center px-10 py-4 bg-[#c9a961] text-black font-medium text-[15px] tracking-wide uppercase rounded-sm hover:bg-[#d4b872] hover:shadow-[0_0_30px_rgba(201,169,97,0.3)] transition-all duration-300 min-w-[220px] justify-center" data-id="element-146">
            {t.hero.explore}
          </a>
          <a href="#contact" className="inline-flex items-center px-10 py-4 text-white font-medium text-[15px] tracking-wide uppercase rounded-sm border border-white/30 hover:border-[#c9a961] hover:text-[#c9a961] transition-all duration-300 min-w-[220px] justify-center backdrop-blur-sm" data-id="element-147">
            {t.hero.contact}
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3" data-id="element-148">
        <span className="text-white/30 text-[10px] uppercase tracking-[0.3em]" data-id="element-149">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 6, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-[1px] h-10 bg-gradient-to-b from-[#c9a961]/60 to-transparent" data-id="element-150" />
      </motion.div>
    </section>;
}